var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pa-0",class:{ 'font-weight-bold': _vm.isActive },attrs:{"min-width":"0","plain":"","to":{
        name: _vm.to ? _vm.to : '',
    }},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }